import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  margin-left: auto;
  margin-right: 3%;
  gap: 5%;
`;
